// Region/market filtering for the Monitoring tab's LocationRoutes rows.
//
// The dashboard's two filters map to different places:
//   - "Region" (MW/NE/WC/S) IS the LocationRoutes `market` field on each row.
//   - "Market" (fulfillment center, e.g. "IL_Chicago") is NOT on the route row
//     (it's null there) — FC lives on OpsLocations, so we map a stop's location
//     id -> FC via `fcByLocationId` (the dashboard's FRIDGE map), mirroring
//     ViewStockingDashboard.
//
// FC is resolved at the ROUTE level, not per row: a route is kept if ANY of its
// stops maps to a selected FC, then ALL of that route's rows are kept (filtering
// row-by-row would drop non-fridge stops and fragment the route). If the FC map
// isn't loaded yet we skip the FC axis rather than wrongly empty the result.
// Empty region (All Regions) / empty market list = no filter on that axis.
const REGION_ALL = 'ALL';

export default function filterMonitoringRoutes(
  routes,
  { region, market, fcByLocationId } = {},
) {
  const regionValue = region && region.value;
  const filterRegion = Boolean(regionValue) && regionValue !== REGION_ALL;
  const marketValues = (market || []).map((m) => m.value).filter(Boolean);
  const fcReady = fcByLocationId && Object.keys(fcByLocationId).length > 0;
  const filterMarket = marketValues.length > 0 && fcReady;

  if (!filterRegion && !filterMarket) return routes;

  // Route names (the join key) whose stops include a selected FC.
  let allowedRouteNames = null;
  if (filterMarket) {
    allowedRouteNames = new Set();
    routes.forEach((r) => {
      const fc = fcByLocationId[r.id];
      if (fc && marketValues.includes(fc) && r.route) {
        allowedRouteNames.add(r.route);
      }
    });
  }

  return routes.filter((r) => {
    if (filterRegion && r.market !== regionValue) return false;
    if (filterMarket && !allowedRouteNames.has(r.route)) return false;
    return true;
  });
}
